import React from 'react';

// Team data with optional LinkedIn links
const teamMembers = [
  {
    name: "Badasa Firdisa",
    role: "Lead Developer & Bioinformatics Specialist",
    description:
     `Developer of TefDB, with an MSc in Bioinformatics and strong experience in software and biological databases, creating tools that make tef research accessible and efficient.`,
    email: "badofirdo11@gmail.com",
    phone: "+251933992667",
    image: `${process.env.PUBLIC_URL}/images/badasa.jpg`,
    linkedin: "https://www.linkedin.com/in/badasa-firdisa/",
  },
  {
    name: "Dr. Abiy Zegeye",
    role: "Advisor",
    description:`Abiy Zegeye (PhD): With broad experience in leveraging technology and data analytics in sectors as diverse as living systems, 
climate and disaster risk management, Dr. Abiy brings together an eclectic mix of expertise that connect elements affecting abiotic and biotic systems towards improving the lives and livelihoods of communities.
Dr. Abiy conceived this knowledgebase platform that is dedicated to tef; 
and guided it through its development and deployment.`,
    email: "abiyze@yahoo.com",
    phone: "+251911645248",
    image: `${process.env.PUBLIC_URL}/images/abiy.jpeg`,
  },
  {
    name: "Dr. Adugna Abdi",
    role: "Scientific Advisor",
    description:
      `Adugna Abdi Woldesemayat (PhD): Associate Professor in Bioinformatics, guiding and supporting the development of TefDB. Dr. Adugna focuses on integrative structural and functional bioinformatics, emphasizing genomic data management, multi-omics integration, and AI-driven applications, while developing scalable web-based systems and contributing to research in genomics, data science, and precision modeling aligned with national and global priorities`,
    email: "adugnaabdi@gmail.com",
    phone: "+251966274642",
    image: `${process.env.PUBLIC_URL}/images/adugna.jpeg`,
    linkedin: "https://www.linkedin.com/in/adugna-abdi/",
  },
];

const Team = () => {
  return (
    <main style={{ maxWidth: 1100, margin: '40px auto', padding: '0 20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center', marginBottom: 50, color: '#2c3e50', fontSize: '2.5rem' }}>
        Meet Our Exceptional Team
      </h1>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2.5rem',
        }}
      >
        {teamMembers.map((member) => (
          <article
            key={member.name}
            style={{
              backgroundColor: '#ffffff',
              borderRadius: 16,
              boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
              padding: '30px 20px',
              textAlign: 'center',
              transition: 'transform 0.3s, box-shadow 0.3s',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.12)';
            }}
          >
            <img
              src={member.image}
              alt={`Portrait of ${member.name}`}
              style={{
                width: 140,
                height: 140,
                borderRadius: '50%',
                objectFit: 'cover',
                marginBottom: 20,
                border: '3px solid #3e8ed0',
              }}
            />
            <h2 style={{ margin: '0.5rem 0', fontSize: '1.5rem', color: '#34495e' }}>
              {member.name}
            </h2>
            <h3
              style={{
                margin: '0.3rem 0',
                fontWeight: '500',
                color: '#7f8c8d',
                fontStyle: 'italic',
                fontSize: '1rem',
              }}
            >
              {member.role}
            </h3>
            <p style={{ fontSize: '0.95rem', color: '#555', minHeight: 70, margin: '15px 0' }}>
              {member.description}
            </p>
            <div style={{ marginTop: 15, fontSize: '0.95rem', color: '#2c3e50' }}>
              <p>
                <strong>📧 Email:</strong>{' '}
                <a href={`mailto:${member.email}`} style={{ color: '#3e8ed0', textDecoration: 'none' }}>
                  {member.email}
                </a>
              </p>
              <p>
                <strong>📞 Phone:</strong>{' '}
                <a href={`tel:${member.phone}`} style={{ color: '#3e8ed0', textDecoration: 'none' }}>
                  {member.phone}
                </a>
              </p>
              {member.linkedin && (
                <p>
                  <strong>🔗 LinkedIn:</strong>{' '}
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#0e76a8', textDecoration: 'none' }}
                  >
                    Profile
                  </a>
                </p>
              )}
            </div>
          </article>
        ))}
      </div>
    </main>
  );
};

export default Team;

